import { ValidationError } from '../util/FormValidation';
import { StripeErrorCode } from '../const/stripe/errorcodes';
import { convertStripeToFirstPayCardBrand } from '../const/stripe/CardBrandType';
export class StripeElementTokenGenerator {
    constructor(stripe, cardElement, event) {
        this.stripe = stripe;
        this.cardElement = cardElement;
        this.event = event;
    }
    change(stripe, cardElement, event) {
        this.stripe = stripe;
        this.cardElement = cardElement;
        this.event = event;
    }
    validate() {
        const { stripe, cardElement, event } = this;
        const errors = new ValidationError();
        // 初期化されてない
        if (stripe === null || cardElement === null || event === null) {
            errors.add('token', 'カード番号、有効期限、セキュリティコードを入力してください');
            return errors;
        }
        // 未入力の項目があるパターン
        if (!event.complete) {
            errors.add('token', 'カード番号、有効期限、セキュリティコードを入力してください');
            return errors;
        }
        return errors;
    }
    async createToken() {
        const { stripe, cardElement, event } = this;
        // 初期化されてない
        if (stripe === null || cardElement === null || event === null) {
            throw Error('カード番号、有効期限、セキュリティコードを入力してください');
        }
        const { token, error } = await stripe.createToken(cardElement);
        // エラーがある場合
        if (typeof error !== 'undefined') {
            const message = StripeErrorCode.errorCodeToMsg(error.code ?? '', error.decline_code ?? '');
            throw new Error(message);
        }
        const tokenResult = token;
        const card = tokenResult.card;
        return {
            cardBrandType: convertStripeToFirstPayCardBrand(event.brand),
            cardno: `************${card.last4}`,
            holdername: card.name,
            expiremonth: `0${card.exp_month}`.slice(-2),
            expireyear: `${card.exp_year}`,
            cvc: null,
            sequence: null,
            paymentMethod: "BUNDLE",
            payTimes: 1,
            tokens: [tokenResult.id, card.id],
            payType: "INPUT",
        };
    }
}
